import React from 'react'

export const IconAllPins = () => {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.1013 13.5803V7.3987C24.1013 5.33239 22.6331 4.48411 20.8496 5.50639L18.2939 6.96369C17.7392 7.27908 16.8148 7.3117 16.2384 7.01807L10.5289 4.16873C9.9525 3.88597 9.02809 3.90772 8.47345 4.2231L3.76443 6.92019C3.15541 7.2682 2.66602 8.11648 2.66602 8.80162V19.3833C2.66602 21.4496 4.13419 22.2979 5.91774 21.2756L8.47345 19.8183C9.02809 19.503 9.9525 19.4703 10.5289 19.764L13.3837 21.1941"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.48535 4.69092V18.8289"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2822 7.54053L17.2822 11.4708"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1796 16.2462C14.6292 9.87395 24.0699 9.88131 25.5121 16.2536C26.3583 19.9916 24.0331 23.1557 21.9949 25.113C20.5158 26.5405 18.1759 26.5405 16.6895 25.113C14.6586 23.1557 12.3334 19.9843 13.1796 16.2462Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M19.3456 19.8811C20.6135 19.8811 21.6414 18.8533 21.6414 17.5853C21.6414 16.3174 20.6135 15.2896 19.3456 15.2896C18.0777 15.2896 17.0498 16.3174 17.0498 17.5853C17.0498 18.8533 18.0777 19.8811 19.3456 19.8811Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  )
}
